import { useEffect, useRef } from 'react';

export function useDirtyChangeReport(
  hasChanges: boolean,
  onDirtyChange?: (dirty: boolean) => void
) {
  const onDirtyChangeRef = useRef(onDirtyChange);
  onDirtyChangeRef.current = onDirtyChange;

  useEffect(() => {
    onDirtyChangeRef.current?.(hasChanges);
  }, [hasChanges]);

  useEffect(() => {
    return () => onDirtyChangeRef.current?.(false);
  }, []);
}
